import Breadcrumbs from 'components/atomic/Breadcrumbs'
import LazyLoad from 'react-lazyload'
import ListingAlgolia from 'components/ListingAlgolia'
import MetaSeo from 'components/atomic/MetaSeo'
import { PAGINEDETAIL } from 'utils/endpoint'
import { api } from 'utils'

const StrumentiAll = ({ pagina }) => {
  return (
    <main className="listing-page">
      <MetaSeo seo={pagina.seo} />
      <div className="w-container-fluid u-before-section">
        <div className="w-container">
          <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
        </div>

        <section className="listing-page__header">
          <div className="w-container">
            {pagina.main_image ? (
              <LazyLoad height={160} offset={100} once>
                <img
                  src={pagina.main_image}
                  alt={pagina.titolo?.toAltTitle()}
                  title={pagina.titolo?.toAltTitle()}
                  className="listing-page__image"
                />
              </LazyLoad>
            ) : null}

            <h1 className="listing-page__title listing-page__title--black">{pagina.titolo}</h1>

            <p className="listing-page__abstract">{pagina.descrizione}</p>
          </div>
        </section>
      </div>
      <section className="listing-page__list-section section">
        <ListingAlgolia models={['strumento']} onlyOneType />
      </section>
    </main>
  )
}

export const getStaticProps = async () => {
  const pageResponse = await api.get(PAGINEDETAIL, {
    params: {
      chiave: 'strumenti-all',
    },
  })
  const pagina = await pageResponse.data

  const toolbarProps = { toolbarPage: pagina }

  return { props: { pagina, ...toolbarProps }, revalidate: 60 * 60 }
}

export default StrumentiAll
